import React from 'react';
import { PillIcon, PlusIcon, ClockIcon, CalendarIcon, BellIcon } from 'lucide-react';
export const SupplementPlanner: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-874">
      <div className="mb-6" data-id="element-875">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-876">Supplement Planner</h1>
        <p className="text-gray-600" data-id="element-877">
          Plane und tracke deine Nahrungsergänzungsmittel
        </p>
      </div>
      {/* Today's Supplements */}
      <section className="mb-8" data-id="element-878">
        <div className="flex justify-between items-center mb-4" data-id="element-879">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-880">
            Heute einzunehmen
          </h2>
          <button className="bg-purple-600 text-white rounded-lg px-3 py-1 text-sm font-medium flex items-center" data-id="element-881">
            <PlusIcon size={16} className="mr-1" data-id="element-882" /> Hinzufügen
          </button>
        </div>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-883">
          <div className="p-4 border-b border-gray-100" data-id="element-884">
            <div className="flex items-center" data-id="element-885">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-886">
                <PillIcon size={20} className="text-blue-600" data-id="element-887" />
              </div>
              <div className="flex-1" data-id="element-888">
                <div className="flex justify-between" data-id="element-889">
                  <p className="font-medium text-gray-800" data-id="element-890">NAD+ Booster</p>
                  <p className="text-sm text-gray-500" data-id="element-891">2 Kapseln</p>
                </div>
                <div className="flex items-center mt-1" data-id="element-892">
                  <ClockIcon size={14} className="text-gray-400 mr-1" data-id="element-893" />
                  <p className="text-sm text-gray-500" data-id="element-894">In 25 Minuten (10:30)</p>
                </div>
              </div>
              <button className="ml-4 bg-purple-100 text-purple-600 px-3 py-1 rounded-lg text-sm font-medium" data-id="element-895">
                Nehmen
              </button>
            </div>
          </div>
          <div className="p-4 border-b border-gray-100" data-id="element-896">
            <div className="flex items-center" data-id="element-897">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-898">
                <PillIcon size={20} className="text-green-600" data-id="element-899" />
              </div>
              <div className="flex-1" data-id="element-900">
                <div className="flex justify-between" data-id="element-901">
                  <p className="font-medium text-gray-800" data-id="element-902">
                    Magnesium Bisglycinat
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-903">300mg</p>
                </div>
                <div className="flex items-center mt-1" data-id="element-904">
                  <ClockIcon size={14} className="text-gray-400 mr-1" data-id="element-905" />
                  <p className="text-sm text-gray-500" data-id="element-906">
                    Vor dem Schlafengehen (22:00)
                  </p>
                </div>
              </div>
              <button className="ml-4 bg-gray-100 text-gray-600 px-3 py-1 rounded-lg text-sm font-medium" data-id="element-907">
                Später
              </button>
            </div>
          </div>
          <div className="p-4" data-id="element-908">
            <div className="flex items-center" data-id="element-909">
              <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-910">
                <PillIcon size={20} className="text-orange-600" data-id="element-911" />
              </div>
              <div className="flex-1" data-id="element-912">
                <div className="flex justify-between" data-id="element-913">
                  <p className="font-medium text-gray-800" data-id="element-914">Vitamin D3 + K2</p>
                  <p className="text-sm text-gray-500" data-id="element-915">5000 IE</p>
                </div>
                <div className="flex items-center mt-1" data-id="element-916">
                  <ClockIcon size={14} className="text-gray-400 mr-1" data-id="element-917" />
                  <p className="text-sm text-gray-500 line-through" data-id="element-918">
                    Heute morgen (8:00)
                  </p>
                </div>
              </div>
              <span className="ml-4 bg-green-100 text-green-600 px-3 py-1 rounded-lg text-sm font-medium" data-id="element-919">
                Erledigt
              </span>
            </div>
          </div>
        </div>
      </section>
      {/* Supplement Stack */}
      <section className="mb-8" data-id="element-920">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-921">
          Dein Supplement Stack
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-922">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-923">
            <div className="flex items-center mb-3" data-id="element-924">
              <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-925">
                <PillIcon size={20} className="text-blue-600" data-id="element-926" />
              </div>
              <div data-id="element-927">
                <p className="font-medium text-gray-800" data-id="element-928">NAD+ Booster</p>
                <div className="flex items-center mt-1" data-id="element-929">
                  <CalendarIcon size={14} className="text-gray-400 mr-1" data-id="element-930" />
                  <p className="text-xs text-gray-500" data-id="element-931">Täglich, morgens</p>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-2" data-id="element-932">
              Unterstützt die zelluläre Energieproduktion und
              Anti-Aging-Prozesse.
            </p>
            <div className="flex justify-between text-xs text-gray-500" data-id="element-933">
              <span data-id="element-934">Bestand: 45 Kapseln</span>
              <span data-id="element-935">Nachbestellen in 22 Tagen</span>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-936">
            <div className="flex items-center mb-3" data-id="element-937">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-938">
                <PillIcon size={20} className="text-green-600" data-id="element-939" />
              </div>
              <div data-id="element-940">
                <p className="font-medium text-gray-800" data-id="element-941">
                  Magnesium Bisglycinat
                </p>
                <div className="flex items-center mt-1" data-id="element-942">
                  <CalendarIcon size={14} className="text-gray-400 mr-1" data-id="element-943" />
                  <p className="text-xs text-gray-500" data-id="element-944">Täglich, abends</p>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-2" data-id="element-945">
              Fördert Entspannung, verbessert Schlafqualität und
              Muskelregeneration.
            </p>
            <div className="flex justify-between text-xs text-gray-500" data-id="element-946">
              <span data-id="element-947">Bestand: 28 Portionen</span>
              <span data-id="element-948">Nachbestellen in 14 Tagen</span>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-949">
            <div className="flex items-center mb-3" data-id="element-950">
              <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-951">
                <PillIcon size={20} className="text-orange-600" data-id="element-952" />
              </div>
              <div data-id="element-953">
                <p className="font-medium text-gray-800" data-id="element-954">Vitamin D3 + K2</p>
                <div className="flex items-center mt-1" data-id="element-955">
                  <CalendarIcon size={14} className="text-gray-400 mr-1" data-id="element-956" />
                  <p className="text-xs text-gray-500" data-id="element-957">Täglich, morgens</p>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-2" data-id="element-958">
              Unterstützt Knochengesundheit, Immunsystem und Herzgesundheit.
            </p>
            <div className="flex justify-between text-xs text-gray-500" data-id="element-959">
              <span data-id="element-960">Bestand: 52 Portionen</span>
              <span data-id="element-961">Nachbestellen in 50 Tagen</span>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-962">
            <div className="flex items-center mb-3" data-id="element-963">
              <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-964">
                <PillIcon size={20} className="text-purple-600" data-id="element-965" />
              </div>
              <div data-id="element-966">
                <p className="font-medium text-gray-800" data-id="element-967">Omega-3 Fischöl</p>
                <div className="flex items-center mt-1" data-id="element-968">
                  <CalendarIcon size={14} className="text-gray-400 mr-1" data-id="element-969" />
                  <p className="text-xs text-gray-500" data-id="element-970">Täglich, mit Mahlzeit</p>
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-2" data-id="element-971">
              Fördert Gehirngesundheit und reduziert Entzündungen im Körper.
            </p>
            <div className="flex justify-between text-xs text-gray-500" data-id="element-972">
              <span data-id="element-973">Bestand: 18 Portionen</span>
              <span className="text-red-500 font-medium" data-id="element-974">
                Bald nachbestellen!
              </span>
            </div>
          </div>
        </div>
      </section>
      {/* Recommendations */}
      <section data-id="element-975">
        <div className="flex justify-between items-center mb-4" data-id="element-976">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-977">
            Empfehlungen für dich
          </h2>
          <span className="text-sm text-purple-600" data-id="element-978">
            Basierend auf deinen Werten
          </span>
        </div>
        <div className="bg-purple-50 rounded-xl p-4 mb-4" data-id="element-979">
          <div className="flex items-center mb-3" data-id="element-980">
            <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-981">
              <BellIcon size={20} className="text-purple-600" data-id="element-982" />
            </div>
            <p className="font-medium text-gray-800" data-id="element-983">
              Dein Vitamin D-Wert ist niedrig
            </p>
          </div>
          <p className="text-sm text-gray-600 mb-3" data-id="element-984">
            Basierend auf deinen letzten Blutwerten empfehlen wir eine erhöhte
            Dosierung von Vitamin D3.
          </p>
          <button className="bg-purple-600 text-white px-4 py-2 rounded-lg text-sm font-medium" data-id="element-985">
            Dosierung anpassen
          </button>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-986">
          <p className="font-medium text-gray-800 mb-2" data-id="element-987">
            Weitere Empfehlungen für dich
          </p>
          <ul className="space-y-2 text-sm text-gray-600" data-id="element-988">
            <li className="flex items-center" data-id="element-989">
              <PillIcon size={16} className="text-purple-600 mr-2" data-id="element-990" />
              Coenzym Q10 für mehr Energie
            </li>
            <li className="flex items-center" data-id="element-991">
              <PillIcon size={16} className="text-purple-600 mr-2" data-id="element-992" />
              Ashwagandha für Stressreduktion
            </li>
            <li className="flex items-center" data-id="element-993">
              <PillIcon size={16} className="text-purple-600 mr-2" data-id="element-994" />
              Probiotika für Darmgesundheit
            </li>
          </ul>
        </div>
      </section>
    </div>;
};